import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { IconComponent, trackByFactory } from '@mode/capra';
import { GoogleSheetUploadFacade } from '@mode/dataset/google/contract';
import { ReportTypes } from '@mode/shared/contract-common';
import { AnalyticsEvent, SharedUtilSegmentModule } from '@mode/shared/util-segment';
import {
  existingDataOption,
  reusableDatasetOption,
  uploadSheetOption,
  writeSqlOption,
} from './report-creation-menu-items';
import { LocalStorageService, MetaTagsService } from '@mode/shared/util-js';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent, SharedUtilSegmentModule],
  selector: 'mode-report-creation-shortcuts',
  templateUrl: './report-creation-shortcuts.component.html',
  styleUrls: ['./report-creation-shortcuts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportCreationShortcutsComponent implements OnInit {
  @Input() org = '';
  menuItems: ReportTypes.ReportCreationMenuItem[] = [];
  readonly trackByFn = trackByFactory<ReportTypes.ReportCreationMenuItem>(({ title }) => title);

  constructor(
    private _uploadSheetFacade: GoogleSheetUploadFacade,
    private _window: Window,
    private meta: MetaTagsService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.menuItems = [
      existingDataOption({
        location: AnalyticsEvent.SubContext.MyWorkShortCuts,
        action: AnalyticsEvent.Name.UseExistingData,
      }),
      writeSqlOption(this.org, {
        location: AnalyticsEvent.SubContext.MyWorkShortCuts,
        action: AnalyticsEvent.Name.NewQuery,
      }),
      uploadSheetOption(
        'Create a Dataset from a Worksheet',
        AnalyticsEvent.SubContext.GoogleSheetUploadTile,
        this.localStorageService,
        this.meta
      ),
      reusableDatasetOption(this.org, {
        location: AnalyticsEvent.SubContext.MyWorkShortCuts,
        action: AnalyticsEvent.Name.NewDataset,
      }),
    ];
  }
  async onClick(event: MouseEvent, testAttr: string, route?: string) {
    if (testAttr === 'upload-new-sheet') {
      event.preventDefault();
      this._uploadSheetFacade.launchDialog();
    } else if (route) {
      this._window.location.href = route;
    }
  }
}
